import { AnimatePresence, motion } from 'motion/react'
import { transitions } from '@/lib/motion/presets'
import type { CollapseProps } from './Collapse.types'

// Height reveal on the house expand/collapse pair; the child owns its own padding.
export function Collapse({ open, children, className }: CollapseProps) {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{
            height: 'auto',
            opacity: 1,
            transition: transitions.expand,
          }}
          exit={{ height: 0, opacity: 0, transition: transitions.collapse }}
          className={className ?? 'overflow-hidden'}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
